import { createApp } from 'vue';
import Statistics from './Statistics.vue';

export const initStatistics = () => {
  if (!document.querySelector('#offer-statistics')) {
    return;
  }

  const component = {
    components: { Statistics },
    template: '<Statistics/>',
  };

  createApp(component).mount('#offer-statistics');
};
